import * as types from '../actions/action-types';

const defaults = {
  loading:true,
  data: []
};

export default (store = defaults, action) => {
  switch (action.type) {
    case types.COUNTY_PROVIDERS_RECEIVED:
      return {
        ...store,
        loading: false,
        data: action.data
      };
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/provider-reducer.js